import { IconLoader } from '@ui/src';
import AdditionalInfoBlock from '../../../individual/aml/additional-info-block';
import { AccountsFlowsTypes } from './types';
import AccountFlowCurrency from './account-flow-currency';

import cn from './styles.module.css';

const AccountsFlows = ({
  accountsFlowsIsLoading,
  accountsFlowsIsFetching,
  accountsFlowsValues,
  errors,
  setAccountsFlowsValues,
  currenciesList,
  status,
}: AccountsFlowsTypes) => {
  const accountsFlowsCurrencies: string[] = [];

  accountsFlowsValues?.forEach((item) => {
    if (
      !accountsFlowsCurrencies?.find(
        (currencyId) => currencyId === item.currencyId,
      )
    ) {
      accountsFlowsCurrencies.push(item.currencyId);
    }
  });

  return (
    <AdditionalInfoBlock title="Expected flows on own account">
      {!accountsFlowsIsLoading &&
        !accountsFlowsIsFetching &&
        accountsFlowsValues &&
        accountsFlowsValues?.length > 0 && (
          <div className={cn.expectedFlowsHint}>
            Currencies selected in the&nbsp;
            <strong>
              &quot;Purpose for establishing business relationship&quot;
            </strong>
            &nbsp; section
          </div>
        )}
      <div className={cn.accountsCurrenciesList}>
        {errors?.questionnairesAccountsFlows?.message && (
          <div className={cn.questionnarieError}>
            {errors?.questionnairesAccountsFlows?.message}
          </div>
        )}
        {(accountsFlowsIsLoading || accountsFlowsIsFetching) && (
          <div className={cn.accountsCurrenciesLoader}>
            <IconLoader />
          </div>
        )}
        {!accountsFlowsValues?.length && (
          <div className={cn.emptyAccountsFlows}>
            Add currencies in&nbsp;
            <strong>
              &quot;Purpose for establishing business relationship&quot;
            </strong>
          </div>
        )}
        {accountsFlowsCurrencies?.map((item) => (
          <AccountFlowCurrency
            key={item}
            accountsFlows={accountsFlowsValues}
            accountsFlowsValues={accountsFlowsValues?.filter(
              (accountsFlow) => accountsFlow.currencyId === item,
            )}
            setAccountsFlowsValues={setAccountsFlowsValues}
            currencyId={item}
            currenciesList={currenciesList}
            status={status}
          />
        ))}
      </div>
    </AdditionalInfoBlock>
  );
};

export default AccountsFlows;
